<mat-slide-toggle
	[ngModel]="showPricesWithTax.get$ | async"
	(ngModelChange)="showPricesWithTax.set($event)"
>
	<span i18n="@@VatToggleText">VAT</span>
	@if (taxMultiplier) {
		<span>&nbsp;{{ taxMultiplier | percent: '1.0-1' }}</span>
	}
</mat-slide-toggle>
